<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-plus" @click="handleAdd">新增发布</el-button>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-input class="search-input" size="small" placeholder="请输入标题名称" v-model="searchInfo.title"></el-input>
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <div class="picture-list" v-loading="loading">
        <el-row :gutter="20" justify="center">
          <el-col style="width:20%" v-for="(item) in productList" :key="item.id">
            <el-card :body-style="{ padding: '5px'}">
              <div class="product-poster">
                <img class="product-poster-img" :src="item.poster" @click="handleImgPreview(item.poster)"/>
              </div>
              <el-row class="product-info">
                <el-col :span="18">
                  <el-tooltip class="item" effect="dark" :content="item.title" placement="top">
                    <span class="product-name">{{item.title}}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="6" class="bottom">
                  <span class="function">
                    <span @click="handleEdit(item.id)" title="编辑"><i class="el-icon-edit-outline"></i></span>
                    <!--<span v-if="item.status!==1" title="发布" @click="handlePublish(item.id)"><i class="el-icon-s-promotion"></i></span>-->
                    <!--<span v-if="item.status===1" title="下架" @click="handleOff(item.id)"><i class="el-icon-download"></i></span>-->
                    <span title="删除" @click="handleDelete(item.id)"><i class="el-icon-delete-solid"></i></span>
                  </span>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </section>
</template>
<script>
  import { listDynamicDuty, deleteDynamicDuty } from '@/api/restapi.js'
  export default {
    data () {
      return {
        searchInfo: {
          name: ''
        },
        loading: false,
        productList: [],
        pageInfo: {
          page: 1,
          total: 0,
          size: 10
        }
      }
    },
    mounted () {
      this.searchList()
    },
    methods: {
      handleAdd () {
        this.$router.push('/publishDetail')
      },
      handleSearch () {
        this.pageInfo.page = 1
        this.searchList()
      },
      searchList () {
        this.loading = true
        listDynamicDuty(this.pageInfo.page,this.pageInfo.size,this.searchInfo).then(res => {
          this.loading = false
          if (res.data.code === 0) {
            this.productList = res.data.data.list
            this.pageInfo.total = res.data.data.total
          }else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        }).catch(err => {
          this.loading = false
        })
      },
      handleImgPreview (poster) {},
      handleEdit (id){
        this.$router.push('/publishDetail?id=' + id)
      },
      handleDelete (id) {
        this.$confirm('确认要删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteDynamicDuty(id).then(res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              })
              this.searchList()
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              showClose: true,
              message: '系统异常',
              type: 'error'
            })
          })
        })
      },
      handleSizeChange (val) {
        this.pageInfo.size = val
        this.searchList()
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.searchList()
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
  .picture-list {
    height: 450px;
    overflow: scroll;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 10px;
  }
  .picture-list .el-col{
    margin-top: 10px;
  }
  .product-poster {
    width: 100%;
    height: 120px;
    position: relative;
    text-align: center;
  }
  .product-poster .product-poster-img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .product-off-mark{
    position: absolute;
    top: -10px;
    right: -10px;
    height: 60px;
  }
  .page-bottom {
    width: 100%;
    text-align: right;
  }
  .product-info {
    margin-top: 5px;
  }
  .product-name {
    color: #07438A;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
    display: block;
  }
  .bottom {
    text-align: right;
  }
  .bottom .function {
    color: #07438A;
    font-size: 18px;
  }
  .bottom .function >>> span{
    cursor: pointer;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
</style>



// WEBPACK FOOTER //
// src/components/Publish.vue